import { getTheme } from "./global-styles";
import { ConfigModel } from "../features/configuration/configuration-types";

export const useGlobalStyle = (configuration: ConfigModel) => {
  return {
    theme: getTheme(configuration)
  };
};
